import PropTypes from 'prop-types';
import { useState } from 'react';
import { AccordionCard } from '@/components/AccordionCard';
import { ReactComponent as SearchIcon } from '@/assets/svgs/DesignSystem/search-icon.svg';

export const PrincipalsCard = ({ principals, title = "Recipient's Principals" }) => {
	const [searchTerm, setSearchTerm] = useState('');

	if (!principals || principals.length === 0) {
		return null;
	}

	const filteredPrincipals = principals.filter((principal) => {
		const searchLower = searchTerm.toLowerCase();
		const nameMatch = principal.name?.toLowerCase().includes(searchLower);
		const uenMatch = principal.uenNo?.toLowerCase().includes(searchLower);
		return nameMatch || uenMatch;
	});

	const principalsList = filteredPrincipals.map((principal) => (
		<div className="principals-card__item" key={principal.uenNo}>
			{principal.name && (
				<div className="principals-card__item__name">
					{principal.name}
				</div>
			)}
			{principal.uenNo && (
				<div className="principals-card__item__uen">
					UEN: {principal.uenNo}
				</div>
			)}
		</div>
	));

	const cardTitle = `${title} (${principals.length})`;

	return (
		<AccordionCard
			title={cardTitle}
			className="principals-card"
		>
			<div className="principals-card__search">
				<SearchIcon className="principals-card__search-icon" />
				<input
					type="text"
					className="principals-card__search-input"
					placeholder="Search"
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
				/>
			</div>
			<div className="principals-card__list">
				{principalsList}
			</div>
		</AccordionCard>
	);
};

PrincipalsCard.propTypes = {
	principals: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			uenNo: PropTypes.string.isRequired,
			type: PropTypes.string
		})
	).isRequired,
	title: PropTypes.string
};

export default PrincipalsCard;
